/* tslint:disable */
/* eslint-disable */
/**
 * ONB Services
 * ONB counseling centers service api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddAclDto
 */
export interface AddAclDto {
    /**
     * 
     * @type {string}
     * @memberof AddAclDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'streetName': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'houseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'addressSupplement'?: string;
    /**
     * 
     * @type {RegionType}
     * @memberof AddressDto
     */
    'region': RegionType;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'areaCode': string;
}
/**
 * 
 * @export
 * @interface AppInfoDto
 */
export interface AppInfoDto {
    /**
     * 
     * @type {string}
     * @memberof AppInfoDto
     */
    'backendVersion'?: string;
}
/**
 * 
 * @export
 * @interface AppointmentDto
 */
export interface AppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'counselingCenterId': string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'counselingCenterArea'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'advisorId': string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'advisorName': string;
    /**
     * 
     * @type {AppointmentType}
     * @memberof AppointmentDto
     */
    'type': AppointmentType;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'location': string;
    /**
     * 
     * @type {Array<ClientData>}
     * @memberof AppointmentDto
     */
    'clients': Array<ClientData>;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'endTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDto
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'cancellationSource'?: AppointmentDtoCancellationSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'cancellationNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'cancelledBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'chatRoomId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDto
     */
    'jitsiRoomId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AppointmentDtoCancellationSourceEnum {
    Advisor = 'ADVISOR',
    Client = 'CLIENT'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum AppointmentType {
    Chat = 'CHAT',
    Video = 'VIDEO'
}

/**
 * 
 * @export
 * @interface CancelAppointmentDto
 */
export interface CancelAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof CancelAppointmentDto
     */
    'source': CancelAppointmentDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CancelAppointmentDto
     */
    'note'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CancelAppointmentDtoSourceEnum {
    Advisor = 'ADVISOR',
    Client = 'CLIENT'
}

/**
 * 
 * @export
 * @interface ChatTokenDto
 */
export interface ChatTokenDto {
    /**
     * 
     * @type {string}
     * @memberof ChatTokenDto
     */
    'chatToken'?: string;
}
/**
 * 
 * @export
 * @interface ClientData
 */
export interface ClientData {
    /**
     * 
     * @type {string}
     * @memberof ClientData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientData
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientData
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientData
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientData
     */
    'cancellationNote'?: string;
}
/**
 * 
 * @export
 * @interface ClientDto
 */
export interface ClientDto {
    /**
     * 
     * @type {string}
     * @memberof ClientDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDto
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface ContentDisposition
 */
export interface ContentDisposition {
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'filename'?: string;
    /**
     * 
     * @type {ContentDispositionCharset}
     * @memberof ContentDisposition
     */
    'charset'?: ContentDispositionCharset;
    /**
     * 
     * @type {number}
     * @memberof ContentDisposition
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'modificationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentDisposition
     */
    'readDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentDisposition
     */
    'inline'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentDisposition
     */
    'attachment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentDisposition
     */
    'formData'?: boolean;
}
/**
 * 
 * @export
 * @interface ContentDispositionCharset
 */
export interface ContentDispositionCharset {
    /**
     * 
     * @type {boolean}
     * @memberof ContentDispositionCharset
     */
    'registered'?: boolean;
}
/**
 * 
 * @export
 * @interface CounselingCenterDetailsDto
 */
export interface CounselingCenterDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'id': string;
    /**
     * 
     * @type {ObjectStatus}
     * @memberof CounselingCenterDetailsDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CounselingCenterDetailsDto
     */
    'hiddenAddress'?: boolean;
    /**
     * 
     * @type {AddressDto}
     * @memberof CounselingCenterDetailsDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {GeoLocation}
     * @memberof CounselingCenterDetailsDto
     */
    'location'?: GeoLocation;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'information'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'aboutUs'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'appointmentInfo'?: string;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof CounselingCenterDetailsDto
     */
    'updatedBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDetailsDto
     */
    'chatCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'chatConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDetailsDto
     */
    'videoCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'videoConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDetailsDto
     */
    'mailCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'mailConfig'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'phoneCounseling'?: string;
    /**
     * 
     * @type {Array<OpeningHoursDto>}
     * @memberof CounselingCenterDetailsDto
     */
    'openingHours'?: Array<OpeningHoursDto>;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof CounselingCenterDetailsDto
     */
    'createdBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDetailsDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Array<LegalEntityShortDto>}
     * @memberof CounselingCenterDetailsDto
     */
    'legalEntities': Array<LegalEntityShortDto>;
    /**
     * 
     * @type {{ [key: string]: Array<LookupValueDto>; }}
     * @memberof CounselingCenterDetailsDto
     */
    'lookupValues'?: { [key: string]: Array<LookupValueDto>; };
}
/**
 * 
 * @export
 * @interface CounselingCenterDto
 */
export interface CounselingCenterDto {
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'id': string;
    /**
     * 
     * @type {ObjectStatus}
     * @memberof CounselingCenterDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CounselingCenterDto
     */
    'hiddenAddress'?: boolean;
    /**
     * 
     * @type {AddressDto}
     * @memberof CounselingCenterDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {GeoLocation}
     * @memberof CounselingCenterDto
     */
    'location'?: GeoLocation;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'information'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'aboutUs'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'appointmentInfo'?: string;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof CounselingCenterDto
     */
    'updatedBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDto
     */
    'chatCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'chatConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDto
     */
    'videoCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'videoConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterDto
     */
    'mailCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'mailConfig'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'phoneCounseling'?: string;
    /**
     * 
     * @type {Array<OpeningHoursDto>}
     * @memberof CounselingCenterDto
     */
    'openingHours'?: Array<OpeningHoursDto>;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof CounselingCenterDto
     */
    'createdBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselingCenterDto
     */
    'legalEntityIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselingCenterDto
     */
    'lookupValueIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CounselingCenterSearchResultDto
 */
export interface CounselingCenterSearchResultDto {
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'id': string;
    /**
     * 
     * @type {ObjectStatus}
     * @memberof CounselingCenterSearchResultDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'name': string;
    /**
     * 
     * @type {Array<LegalEntityShortDto>}
     * @memberof CounselingCenterSearchResultDto
     */
    'legalEntities'?: Array<LegalEntityShortDto>;
    /**
     * 
     * @type {AddressDto}
     * @memberof CounselingCenterSearchResultDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {GeoLocation}
     * @memberof CounselingCenterSearchResultDto
     */
    'location'?: GeoLocation;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'area'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CounselingCenterSearchResultDto
     */
    'lookupValueIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CounselingCenterSearchResultDto
     */
    'distance'?: number;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterSearchResultDto
     */
    'chatCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterSearchResultDto
     */
    'videoCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CounselingCenterSearchResultDto
     */
    'mailCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {number}
     * @memberof CounselingCenterSearchResultDto
     */
    'totalAclUsers'?: number;
    /**
     * 
     * @type {number}
     * @memberof CounselingCenterSearchResultDto
     */
    'totalUsers'?: number;
    /**
     * 
     * @type {string}
     * @memberof CounselingCenterSearchResultDto
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CounselingSystemType {
    None = 'NONE',
    Internal = 'INTERNAL',
    External = 'EXTERNAL'
}

/**
 * 
 * @export
 * @interface CreateAppointmentDto
 */
export interface CreateAppointmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'counselingCenterId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'advisorId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'advisorName': string;
    /**
     * 
     * @type {AppointmentType}
     * @memberof CreateAppointmentDto
     */
    'type': AppointmentType;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'location': string;
    /**
     * 
     * @type {Array<ClientData>}
     * @memberof CreateAppointmentDto
     */
    'clients': Array<ClientData>;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'chatRoomId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentDto
     */
    'jitsiRoomId'?: string;
}
/**
 * 
 * @export
 * @interface CreateCounselingCenterDto
 */
export interface CreateCounselingCenterDto {
    /**
     * 
     * @type {ObjectStatus}
     * @memberof CreateCounselingCenterDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCounselingCenterDto
     */
    'legalEntityIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCounselingCenterDto
     */
    'hiddenAddress'?: boolean;
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateCounselingCenterDto
     */
    'address'?: AddressDto;
    /**
     * 
     * @type {GeoLocation}
     * @memberof CreateCounselingCenterDto
     */
    'location'?: GeoLocation;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'information'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'aboutUs'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'appointmentInfo'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CreateCounselingCenterDto
     */
    'chatCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'chatConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CreateCounselingCenterDto
     */
    'videoCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'videoConfig'?: string;
    /**
     * 
     * @type {CounselingSystemType}
     * @memberof CreateCounselingCenterDto
     */
    'mailCounselingSystem'?: CounselingSystemType;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'mailConfig'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCounselingCenterDto
     */
    'phoneCounseling'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCounselingCenterDto
     */
    'lookupValueIds'?: Array<string>;
    /**
     * 
     * @type {Array<OpeningHoursDto>}
     * @memberof CreateCounselingCenterDto
     */
    'openingHours'?: Array<OpeningHoursDto>;
}
/**
 * 
 * @export
 * @interface CreateLegalEntityDto
 */
export interface CreateLegalEntityDto {
    /**
     * 
     * @type {ObjectStatus}
     * @memberof CreateLegalEntityDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLegalEntityDto
     */
    'areas': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'name': string;
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateLegalEntityDto
     */
    'address': AddressDto;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLegalEntityDto
     */
    'registryNumber': string;
}
/**
 * 
 * @export
 * @interface CreateLookupValueDto
 */
export interface CreateLookupValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLookupValueDto
     */
    'area': string;
    /**
     * 
     * @type {LookupValueType}
     * @memberof CreateLookupValueDto
     */
    'type': LookupValueType;
    /**
     * 
     * @type {string}
     * @memberof CreateLookupValueDto
     */
    'usage'?: string;
    /**
     * 
     * @type {I18nStringVo}
     * @memberof CreateLookupValueDto
     */
    'description': I18nStringVo;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DayOfWeekType {
    Monday = 'MONDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
    Thursday = 'THURSDAY',
    Friday = 'FRIDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY'
}

/**
 * 
 * @export
 * @interface EditableLookupValueDto
 */
export interface EditableLookupValueDto {
    /**
     * 
     * @type {string}
     * @memberof EditableLookupValueDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EditableLookupValueDto
     */
    'area': string;
    /**
     * 
     * @type {LookupValueType}
     * @memberof EditableLookupValueDto
     */
    'type': LookupValueType;
    /**
     * 
     * @type {string}
     * @memberof EditableLookupValueDto
     */
    'usage'?: string;
    /**
     * 
     * @type {I18nStringVo}
     * @memberof EditableLookupValueDto
     */
    'description': I18nStringVo;
}
/**
 * 
 * @export
 * @interface FacetResultCounselingCenterSearchResultDto
 */
export interface FacetResultCounselingCenterSearchResultDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof FacetResultCounselingCenterSearchResultDto
     */
    'facets'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<CounselingCenterSearchResultDto>}
     * @memberof FacetResultCounselingCenterSearchResultDto
     */
    'content'?: Array<CounselingCenterSearchResultDto>;
    /**
     * 
     * @type {number}
     * @memberof FacetResultCounselingCenterSearchResultDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface GeoLocation
 */
export interface GeoLocation {
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface HttpHeaders
 */
export interface HttpHeaders {
    [key: string]: Array<string> | any;

    /**
     * 
     * @type {boolean}
     * @memberof HttpHeaders
     */
    'empty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'location'?: string;
    /**
     * 
     * @type {HttpHeadersHost}
     * @memberof HttpHeaders
     */
    'host'?: HttpHeadersHost;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HttpHeaders
     */
    'all'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'lastModified'?: number;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'contentLength'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'connection'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'ifModifiedSince'?: number;
    /**
     * 
     * @type {MediaType}
     * @memberof HttpHeaders
     */
    'contentType'?: MediaType;
    /**
     * 
     * @type {Array<MediaType>}
     * @memberof HttpHeaders
     */
    'acceptPatch'?: Array<MediaType>;
    /**
     * 
     * @type {Array<HttpHeadersAcceptLanguage>}
     * @memberof HttpHeaders
     */
    'acceptLanguage'?: Array<HttpHeadersAcceptLanguage>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'basicAuth'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'cacheControl'?: string;
    /**
     * 
     * @type {Array<MediaType>}
     * @memberof HttpHeaders
     */
    'accept'?: Array<MediaType>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'origin'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'ifNoneMatch'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'pragma'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'upgrade'?: string;
    /**
     * 
     * @type {Array<ContentDispositionCharset>}
     * @memberof HttpHeaders
     */
    'acceptCharset'?: Array<ContentDispositionCharset>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'ifMatch'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'bearerAuth'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof HttpHeaders
     */
    'range'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'expires'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'vary'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'etag'?: string;
    /**
     * 
     * @type {HttpHeadersContentLanguage}
     * @memberof HttpHeaders
     */
    'contentLanguage'?: HttpHeadersContentLanguage;
    /**
     * 
     * @type {ContentDisposition}
     * @memberof HttpHeaders
     */
    'contentDisposition'?: ContentDisposition;
    /**
     * 
     * @type {Set<object>}
     * @memberof HttpHeaders
     */
    'allow'?: Set<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'accessControlAllowHeaders'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'accessControlRequestHeaders'?: Array<string>;
    /**
     * 
     * @type {Array<object>}
     * @memberof HttpHeaders
     */
    'accessControlAllowMethods'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'accessControlMaxAge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeaders
     */
    'accessControlAllowCredentials'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HttpHeaders
     */
    'accessControlAllowOrigin'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HttpHeaders
     */
    'accessControlExposeHeaders'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof HttpHeaders
     */
    'accessControlRequestMethod'?: object;
    /**
     * 
     * @type {Array<HttpHeadersContentLanguage>}
     * @memberof HttpHeaders
     */
    'acceptLanguageAsLocales'?: Array<HttpHeadersContentLanguage>;
    /**
     * 
     * @type {number}
     * @memberof HttpHeaders
     */
    'ifUnmodifiedSince'?: number;
}
/**
 * 
 * @export
 * @interface HttpHeadersAcceptLanguage
 */
export interface HttpHeadersAcceptLanguage {
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersAcceptLanguage
     */
    'range'?: string;
    /**
     * 
     * @type {number}
     * @memberof HttpHeadersAcceptLanguage
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface HttpHeadersContentLanguage
 */
export interface HttpHeadersContentLanguage {
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'variant'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'script'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof HttpHeadersContentLanguage
     */
    'unicodeLocaleAttributes'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof HttpHeadersContentLanguage
     */
    'unicodeLocaleKeys'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'displayLanguage'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'displayScript'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'displayCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'displayVariant'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof HttpHeadersContentLanguage
     */
    'extensionKeys'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'iso3Language'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersContentLanguage
     */
    'iso3Country'?: string;
}
/**
 * 
 * @export
 * @interface HttpHeadersHost
 */
export interface HttpHeadersHost {
    /**
     * 
     * @type {HttpHeadersHostAddress}
     * @memberof HttpHeadersHost
     */
    'address'?: HttpHeadersHostAddress;
    /**
     * 
     * @type {number}
     * @memberof HttpHeadersHost
     */
    'port'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHost
     */
    'unresolved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHost
     */
    'hostName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHost
     */
    'hostString'?: string;
}
/**
 * 
 * @export
 * @interface HttpHeadersHostAddress
 */
export interface HttpHeadersHostAddress {
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHostAddress
     */
    'hostAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHostAddress
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHostAddress
     */
    'hostName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'linkLocalAddress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'multicastAddress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'anyLocalAddress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'loopbackAddress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'siteLocalAddress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'mcglobal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'mcnodeLocal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'mclinkLocal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'mcsiteLocal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpHeadersHostAddress
     */
    'mcorgLocal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HttpHeadersHostAddress
     */
    'canonicalHostName'?: string;
}
/**
 * 
 * @export
 * @interface HttpStatusCode
 */
export interface HttpStatusCode {
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'error'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'is3xxRedirection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'is4xxClientError'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'is1xxInformational'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'is2xxSuccessful'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    'is5xxServerError'?: boolean;
}
/**
 * 
 * @export
 * @interface I18nStringVo
 */
export interface I18nStringVo {
    /**
     * 
     * @type {string}
     * @memberof I18nStringVo
     */
    'de': string;
    /**
     * 
     * @type {string}
     * @memberof I18nStringVo
     */
    'en': string;
}
/**
 * 
 * @export
 * @interface LegalEntityDto
 */
export interface LegalEntityDto {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'id': string;
    /**
     * 
     * @type {ObjectStatus}
     * @memberof LegalEntityDto
     */
    'status'?: ObjectStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegalEntityDto
     */
    'areas': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'name': string;
    /**
     * 
     * @type {AddressDto}
     * @memberof LegalEntityDto
     */
    'address': AddressDto;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'phone2'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'registryNumber': string;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof LegalEntityDto
     */
    'updatedBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {ModifiedByUserDto}
     * @memberof LegalEntityDto
     */
    'createdBy'?: ModifiedByUserDto;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface LegalEntityShortDto
 */
export interface LegalEntityShortDto {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityShortDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityShortDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface LookupValueDto
 */
export interface LookupValueDto {
    /**
     * 
     * @type {string}
     * @memberof LookupValueDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LookupValueDto
     */
    'area'?: string;
    /**
     * 
     * @type {LookupValueType}
     * @memberof LookupValueDto
     */
    'type'?: LookupValueType;
    /**
     * 
     * @type {string}
     * @memberof LookupValueDto
     */
    'usage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupValueDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LookupValueType {
    Language = 'LANGUAGE',
    CounselingType = 'COUNSELING_TYPE',
    Offer = 'OFFER',
    Topic = 'TOPIC',
    Setting = 'SETTING',
    TargetGroup = 'TARGET_GROUP'
}

/**
 * 
 * @export
 * @interface MediaType
 */
export interface MediaType {
    /**
     * 
     * @type {string}
     * @memberof MediaType
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaType
     */
    'subtype'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MediaType
     */
    'parameters'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof MediaType
     */
    'qualityValue'?: number;
    /**
     * 
     * @type {ContentDispositionCharset}
     * @memberof MediaType
     */
    'charset'?: ContentDispositionCharset;
    /**
     * 
     * @type {boolean}
     * @memberof MediaType
     */
    'concrete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaType
     */
    'wildcardType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaType
     */
    'wildcardSubtype'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaType
     */
    'subtypeSuffix'?: string;
}
/**
 * 
 * @export
 * @interface ModifiedByUserDto
 */
export interface ModifiedByUserDto {
    /**
     * 
     * @type {string}
     * @memberof ModifiedByUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ModifiedByUserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifiedByUserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModifiedByUserDto
     */
    'roles'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ObjectStatus {
    Active = 'ACTIVE',
    Disabled = 'DISABLED'
}

/**
 * 
 * @export
 * @interface OpeningHoursDto
 */
export interface OpeningHoursDto {
    /**
     * 
     * @type {DayOfWeekType}
     * @memberof OpeningHoursDto
     */
    'dayOfWeek'?: DayOfWeekType;
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursDto
     */
    'openingTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursDto
     */
    'closingTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface RefreshRequest
 */
export interface RefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshRequest
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface RegionDto
 */
export interface RegionDto {
    /**
     * 
     * @type {RegionType}
     * @memberof RegionDto
     */
    'id'?: RegionType;
    /**
     * 
     * @type {string}
     * @memberof RegionDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegionDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RegionType {
    Burgenland = 'BURGENLAND',
    Carinthia = 'CARINTHIA',
    LowerAustria = 'LOWER_AUSTRIA',
    UpperAustria = 'UPPER_AUSTRIA',
    Salzburg = 'SALZBURG',
    Styria = 'STYRIA',
    Tyrol = 'TYROL',
    Vorarlberg = 'VORARLBERG',
    Vienna = 'VIENNA'
}

/**
 * 
 * @export
 * @interface RegistrationRequest
 */
export interface RegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof RegistrationRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationRequest
     */
    'captchaToken'?: string;
}
/**
 * 
 * @export
 * @interface RemoveClientDto
 */
export interface RemoveClientDto {
    /**
     * 
     * @type {string}
     * @memberof RemoveClientDto
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface ResponseEntityObject
 */
export interface ResponseEntityObject {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResponseEntityObject
     */
    'headers'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {object}
     * @memberof ResponseEntityObject
     */
    'body'?: object;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof ResponseEntityObject
     */
    'statusCode'?: HttpStatusCode;
    /**
     * 
     * @type {number}
     * @memberof ResponseEntityObject
     */
    'statusCodeValue'?: number;
}
/**
 * 
 * @export
 * @interface RestError
 */
export interface RestError {
    /**
     * 
     * @type {number}
     * @memberof RestError
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    'error'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RestError
     */
    'details'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    'uuid'?: string;
    /**
     * 
     * @type {object}
     * @memberof RestError
     */
    'payload'?: object;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    'stacktrace'?: string;
}
/**
 * 
 * @export
 * @interface ResultAppointmentDto
 */
export interface ResultAppointmentDto {
    /**
     * 
     * @type {Array<AppointmentDto>}
     * @memberof ResultAppointmentDto
     */
    'content'?: Array<AppointmentDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultAppointmentDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultClientDto
 */
export interface ResultClientDto {
    /**
     * 
     * @type {Array<ClientDto>}
     * @memberof ResultClientDto
     */
    'content'?: Array<ClientDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultClientDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultEditableLookupValueDto
 */
export interface ResultEditableLookupValueDto {
    /**
     * 
     * @type {Array<EditableLookupValueDto>}
     * @memberof ResultEditableLookupValueDto
     */
    'content'?: Array<EditableLookupValueDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultEditableLookupValueDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultLegalEntityDto
 */
export interface ResultLegalEntityDto {
    /**
     * 
     * @type {Array<LegalEntityDto>}
     * @memberof ResultLegalEntityDto
     */
    'content'?: Array<LegalEntityDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultLegalEntityDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultLookupValueDto
 */
export interface ResultLookupValueDto {
    /**
     * 
     * @type {Array<LookupValueDto>}
     * @memberof ResultLookupValueDto
     */
    'content'?: Array<LookupValueDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultLookupValueDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultString
 */
export interface ResultString {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultString
     */
    'content'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResultString
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface ResultUserDto
 */
export interface ResultUserDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof ResultUserDto
     */
    'content'?: Array<UserDto>;
    /**
     * 
     * @type {number}
     * @memberof ResultUserDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface SettingsDto
 */
export interface SettingsDto {
    /**
     * 
     * @type {string}
     * @memberof SettingsDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsDto
     */
    'previewUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsDto
     */
    'legalEntityRequired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsDto
     */
    'counselingCenterDescriptionDisable'?: boolean;
    /**
     * 
     * @type {Array<LookupValueType>}
     * @memberof SettingsDto
     */
    'enabledLookupValueTypes'?: Array<LookupValueType>;
    /**
     * 
     * @type {Array<LookupValueType>}
     * @memberof SettingsDto
     */
    'requiredLookupValueTypes'?: Array<LookupValueType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SettingsDto
     */
    'lookupValueUsages'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateClientDto
 */
export interface UpdateClientDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientDto
     */
    'oldPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientDto
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'area'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    'legalEntityAreas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'legalEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'legalEntityName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    'counselingCenterIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'totalCounselingCenters'?: number;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add user to counseling center
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclToCounselingCenterByAdmin: async (id: string, addAclDto: AddAclDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addAclToCounselingCenterByAdmin', 'id', id)
            // verify required parameter 'addAclDto' is not null or undefined
            assertParamExists('addAclToCounselingCenterByAdmin', 'addAclDto', addAclDto)
            const localVarPath = `/admin/counseling-centers/{id}/acl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAclDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add user to legal entity
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclToLegalEntityByAdmin: async (id: string, addAclDto: AddAclDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addAclToLegalEntityByAdmin', 'id', id)
            // verify required parameter 'addAclDto' is not null or undefined
            assertParamExists('addAclToLegalEntityByAdmin', 'addAclDto', addAclDto)
            const localVarPath = `/admin/legal-entities/{id}/acl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAclDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add users to counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclsToCounselingCenterByAdmin: async (id: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addAclsToCounselingCenterByAdmin', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('addAclsToCounselingCenterByAdmin', 'requestBody', requestBody)
            const localVarPath = `/admin/counseling-centers/{id}/acls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {CancelAppointmentDto} [cancelAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment: async (id: string, cancelAppointmentDto?: CancelAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelAppointment', 'id', id)
            const localVarPath = `/appointments/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new appointment.
         * @param {CreateAppointmentDto} createAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment: async (createAppointmentDto: CreateAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAppointmentDto' is not null or undefined
            assertParamExists('createAppointment', 'createAppointmentDto', createAppointmentDto)
            const localVarPath = `/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a counseling center.
         * @param {CreateCounselingCenterDto} createCounselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCounselingCenterByAdmin: async (createCounselingCenterDto: CreateCounselingCenterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCounselingCenterDto' is not null or undefined
            assertParamExists('createCounselingCenterByAdmin', 'createCounselingCenterDto', createCounselingCenterDto)
            const localVarPath = `/admin/counseling-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCounselingCenterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a legal entity.
         * @param {CreateLegalEntityDto} createLegalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegalEntityByAdmin: async (createLegalEntityDto: CreateLegalEntityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLegalEntityDto' is not null or undefined
            assertParamExists('createLegalEntityByAdmin', 'createLegalEntityDto', createLegalEntityDto)
            const localVarPath = `/admin/legal-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLegalEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a lookup value.
         * @param {CreateLookupValueDto} createLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLookupValueByAdmin: async (createLookupValueDto: CreateLookupValueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLookupValueDto' is not null or undefined
            assertParamExists('createLookupValueByAdmin', 'createLookupValueDto', createLookupValueDto)
            const localVarPath = `/admin/lookup-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLookupValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclFromCounselingCenterByAdmin: async (id: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAclFromCounselingCenterByAdmin', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAclFromCounselingCenterByAdmin', 'userId', userId)
            const localVarPath = `/admin/counseling-centers/{id}/acl/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user from legal entity
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclFromLegalEntityByAdmin: async (id: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAclFromLegalEntityByAdmin', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAclFromLegalEntityByAdmin', 'userId', userId)
            const localVarPath = `/admin/legal-entities/{id}/acl/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclsFromCounselingCenterByAdmin: async (id: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAclsFromCounselingCenterByAdmin', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteAclsFromCounselingCenterByAdmin', 'requestBody', requestBody)
            const localVarPath = `/admin/counseling-centers/{id}/deleteAcls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAclsFromCounselingCenterByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAllAclsFromCounselingCenterByAdmin', 'id', id)
            const localVarPath = `/admin/counseling-centers/{id}/acls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAppointment', 'id', id)
            const localVarPath = `/appointments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCounselingCenterByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCounselingCenterByAdmin', 'id', id)
            const localVarPath = `/admin/counseling-centers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a legal entity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegalEntityByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLegalEntityByAdmin', 'id', id)
            const localVarPath = `/admin/legal-entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a lookup value
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookupValueByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLookupValueByAdmin', 'id', id)
            const localVarPath = `/admin/lookup-values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdvisors: async (limit?: number, offset?: number, sort?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/appointments/advisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {string} [searchTerm] term for case insensitive contains search
         * @param {string} [counselingCenterIds] comma separated list of counseling center ids
         * @param {string} [counselingCenterAreas] comma separated list of counseling center ids
         * @param {string} [advisorIds] comma separated list of advisor ids
         * @param {AppointmentType} [type] type of an the appointment
         * @param {string} [clientId] id of a client
         * @param {string} [timeFrom] time from
         * @param {string} [timeUntil] time until
         * @param {boolean} [cancelled] can be true, false or null
         * @param {boolean} [notCancelledByAdvisor] return all appointments which are either not cancelled or cancelled by CLIENT
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAppointments: async (searchTerm?: string, counselingCenterIds?: string, counselingCenterAreas?: string, advisorIds?: string, type?: AppointmentType, clientId?: string, timeFrom?: string, timeUntil?: string, cancelled?: boolean, notCancelledByAdvisor?: boolean, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['search-term'] = searchTerm;
            }

            if (counselingCenterIds !== undefined) {
                localVarQueryParameter['counseling-center-ids'] = counselingCenterIds;
            }

            if (counselingCenterAreas !== undefined) {
                localVarQueryParameter['counseling-center-areas'] = counselingCenterAreas;
            }

            if (advisorIds !== undefined) {
                localVarQueryParameter['advisor-ids'] = advisorIds;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client-id'] = clientId;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['time-from'] = (timeFrom as any instanceof Date) ?
                    (timeFrom as any).toISOString() :
                    timeFrom;
            }

            if (timeUntil !== undefined) {
                localVarQueryParameter['time-until'] = (timeUntil as any instanceof Date) ?
                    (timeUntil as any).toISOString() :
                    timeUntil;
            }

            if (cancelled !== undefined) {
                localVarQueryParameter['cancelled'] = cancelled;
            }

            if (notCancelledByAdvisor !== undefined) {
                localVarQueryParameter['notCancelledByAdvisor'] = notCancelledByAdvisor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find clients by filtered by criteria.
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [term] term for case insensitive contains search
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClients: async (ids?: string, term?: string, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCounselingCenters: async (term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/counseling-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (legalEntityId !== undefined) {
                localVarQueryParameter['legal-entity-id'] = legalEntityId;
            }

            if (lookupValueIds !== undefined) {
                localVarQueryParameter['lookup-value-ids'] = lookupValueIds;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (maxDistance !== undefined) {
                localVarQueryParameter['max-distance'] = maxDistance;
            }

            if (facetTypes !== undefined) {
                localVarQueryParameter['facet-types'] = facetTypes;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (updatedAtFrom !== undefined) {
                localVarQueryParameter['updatedAtFrom'] = (updatedAtFrom as any instanceof Date) ?
                    (updatedAtFrom as any).toISOString() :
                    updatedAtFrom;
            }

            if (updatedAtTo !== undefined) {
                localVarQueryParameter['updatedAtTo'] = (updatedAtTo as any instanceof Date) ?
                    (updatedAtTo as any).toISOString() :
                    updatedAtTo;
            }

            if (locationFulltext !== undefined) {
                localVarQueryParameter['locationFulltext'] = locationFulltext;
            }

            if (withOnlineCounseling !== undefined) {
                localVarQueryParameter['withOnlineCounseling'] = withOnlineCounseling;
            }

            if (withChatCounseling !== undefined) {
                localVarQueryParameter['withChatCounseling'] = withChatCounseling;
            }

            if (withVideoCounseling !== undefined) {
                localVarQueryParameter['withVideoCounseling'] = withVideoCounseling;
            }

            if (withMailCounseling !== undefined) {
                localVarQueryParameter['withMailCounseling'] = withMailCounseling;
            }

            if (mailCounselingSystem !== undefined) {
                localVarQueryParameter['mailCounselingSystem'] = mailCounselingSystem;
            }

            if (videoCounselingSystem !== undefined) {
                localVarQueryParameter['videoCounselingSystem'] = videoCounselingSystem;
            }

            if (chatCounselingSystem !== undefined) {
                localVarQueryParameter['chatCounselingSystem'] = chatCounselingSystem;
            }

            if (withInternalCounseling !== undefined) {
                localVarQueryParameter['withInternalCounseling'] = withInternalCounseling;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCounselingCentersByAdmin: async (term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/counseling-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (legalEntityId !== undefined) {
                localVarQueryParameter['legal-entity-id'] = legalEntityId;
            }

            if (lookupValueIds !== undefined) {
                localVarQueryParameter['lookup-value-ids'] = lookupValueIds;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (maxDistance !== undefined) {
                localVarQueryParameter['max-distance'] = maxDistance;
            }

            if (facetTypes !== undefined) {
                localVarQueryParameter['facet-types'] = facetTypes;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (updatedAtFrom !== undefined) {
                localVarQueryParameter['updatedAtFrom'] = (updatedAtFrom as any instanceof Date) ?
                    (updatedAtFrom as any).toISOString() :
                    updatedAtFrom;
            }

            if (updatedAtTo !== undefined) {
                localVarQueryParameter['updatedAtTo'] = (updatedAtTo as any instanceof Date) ?
                    (updatedAtTo as any).toISOString() :
                    updatedAtTo;
            }

            if (locationFulltext !== undefined) {
                localVarQueryParameter['locationFulltext'] = locationFulltext;
            }

            if (withOnlineCounseling !== undefined) {
                localVarQueryParameter['withOnlineCounseling'] = withOnlineCounseling;
            }

            if (withChatCounseling !== undefined) {
                localVarQueryParameter['withChatCounseling'] = withChatCounseling;
            }

            if (withVideoCounseling !== undefined) {
                localVarQueryParameter['withVideoCounseling'] = withVideoCounseling;
            }

            if (withMailCounseling !== undefined) {
                localVarQueryParameter['withMailCounseling'] = withMailCounseling;
            }

            if (mailCounselingSystem !== undefined) {
                localVarQueryParameter['mailCounselingSystem'] = mailCounselingSystem;
            }

            if (videoCounselingSystem !== undefined) {
                localVarQueryParameter['videoCounselingSystem'] = videoCounselingSystem;
            }

            if (chatCounselingSystem !== undefined) {
                localVarQueryParameter['chatCounselingSystem'] = chatCounselingSystem;
            }

            if (withInternalCounseling !== undefined) {
                localVarQueryParameter['withInternalCounseling'] = withInternalCounseling;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find legal entities by given parameters.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [area] professional area
         * @param {RegionType} [region] 
         * @param {ObjectStatus} [status] Status
         * @param {string} [locationFulltext] 
         * @param {string} [name] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLegalEntitiesByAdmin: async (term?: string, ids?: string, area?: string, region?: RegionType, status?: ObjectStatus, locationFulltext?: string, name?: string, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/legal-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (locationFulltext !== undefined) {
                localVarQueryParameter['locationFulltext'] = locationFulltext;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLookupValues: async (types?: string, area?: string, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lookup-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLookupValuesByAdmin: async (types?: string, area?: string, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/lookup-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find users by filtered by criteria.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [legalEntityIds] Comma separated list of legal entity ids
         * @param {string} [area] Area the user is assigned to
         * @param {RegionType} [legalEntityRegion] Region of the legal entity the user belongs to
         * @param {string} [counselingCenterIds] Comma seperated list of counseling center ids
         * @param {string} [role] Role the user is assigned to
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser: async (term?: string, ids?: string, legalEntityIds?: string, area?: string, legalEntityRegion?: RegionType, counselingCenterIds?: string, role?: string, limit?: number, offset?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (legalEntityIds !== undefined) {
                localVarQueryParameter['legalEntityIds'] = legalEntityIds;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (legalEntityRegion !== undefined) {
                localVarQueryParameter['legalEntityRegion'] = legalEntityRegion;
            }

            if (counselingCenterIds !== undefined) {
                localVarQueryParameter['counselingCenterIds'] = counselingCenterIds;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users from counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAclFromCounselingCenterByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAclFromCounselingCenterByAdmin', 'id', id)
            const localVarPath = `/admin/counseling-centers/{id}/acl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users from legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAclFromLegalEntityByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAclFromLegalEntityByAdmin', 'id', id)
            const localVarPath = `/admin/legal-entities/{id}/acl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRegions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get general info about the app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/appinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointment', 'id', id)
            const localVarPath = `/appointments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {AppointmentDto} [appointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentMeetingUrl: async (id: string, appointmentDto?: AppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointmentMeetingUrl', 'id', id)
            const localVarPath = `/appointments/{id}/meetingUrl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signed token used to start chat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/chatToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a counseling center by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCounselingCenter: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCounselingCenter', 'id', id)
            const localVarPath = `/counseling-centers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCounselingCenterByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCounselingCenterByAdmin', 'id', id)
            const localVarPath = `/admin/counseling-centers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download XLS Export for counseling centers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExport: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/counseling-centers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download XLS Export for legal entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExport1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/legal-entities/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a legal entity by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalEntity: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLegalEntity', 'id', id)
            const localVarPath = `/legal-entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalEntityByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLegalEntityByAdmin', 'id', id)
            const localVarPath = `/admin/legal-entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a lookup value by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookupValueByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLookupValueByAdmin', 'id', id)
            const localVarPath = `/admin/lookup-values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} token 
         * @param {string} username 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: async (token: string, username: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getMessages', 'token', token)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getMessages', 'username', username)
            const localVarPath = `/e2echat/messages/{token}/{username}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current application settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of users in a room
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getUserList', 'token', token)
            const localVarPath = `/e2echat/users/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login a client
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest?: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout a client
         * @param {LogoutRequest} [logoutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (logoutRequest?: LogoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh token
         * @param {RefreshRequest} [refreshRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken: async (refreshRequest?: RefreshRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a new client
         * @param {RegistrationRequest} [registrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registrationRequest?: RegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a client
         * @param {RemoveClientDto} [removeClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (removeClientDto?: RemoveClientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a client
         * @param {UpdateClientDto} [updateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateClientDto?: UpdateClientDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an appointment.
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment: async (id: string, appointmentDto: AppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAppointment', 'id', id)
            // verify required parameter 'appointmentDto' is not null or undefined
            assertParamExists('updateAppointment', 'appointmentDto', appointmentDto)
            const localVarPath = `/appointments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a counseling center.
         * @param {string} id 
         * @param {CounselingCenterDto} counselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCounselingCenterByAdmin: async (id: string, counselingCenterDto: CounselingCenterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCounselingCenterByAdmin', 'id', id)
            // verify required parameter 'counselingCenterDto' is not null or undefined
            assertParamExists('updateCounselingCenterByAdmin', 'counselingCenterDto', counselingCenterDto)
            const localVarPath = `/admin/counseling-centers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(counselingCenterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a legal entity.
         * @param {string} id 
         * @param {LegalEntityDto} legalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegalEntityByAdmin: async (id: string, legalEntityDto: LegalEntityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLegalEntityByAdmin', 'id', id)
            // verify required parameter 'legalEntityDto' is not null or undefined
            assertParamExists('updateLegalEntityByAdmin', 'legalEntityDto', legalEntityDto)
            const localVarPath = `/admin/legal-entities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legalEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a lookup value.
         * @param {string} id 
         * @param {EditableLookupValueDto} editableLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLookupValueByAdmin: async (id: string, editableLookupValueDto: EditableLookupValueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLookupValueByAdmin', 'id', id)
            // verify required parameter 'editableLookupValueDto' is not null or undefined
            assertParamExists('updateLookupValueByAdmin', 'editableLookupValueDto', editableLookupValueDto)
            const localVarPath = `/admin/lookup-values/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editableLookupValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add user to counseling center
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAclToCounselingCenterByAdmin(id: string, addAclDto: AddAclDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAclToCounselingCenterByAdmin(id, addAclDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add user to legal entity
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAclToLegalEntityByAdmin(id: string, addAclDto: AddAclDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAclToLegalEntityByAdmin(id, addAclDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add users to counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAclsToCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAclsToCounselingCenterByAdmin(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {CancelAppointmentDto} [cancelAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointment(id: string, cancelAppointmentDto?: CancelAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAppointment(id, cancelAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new appointment.
         * @param {CreateAppointmentDto} createAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointment(createAppointmentDto: CreateAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointment(createAppointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a counseling center.
         * @param {CreateCounselingCenterDto} createCounselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCounselingCenterByAdmin(createCounselingCenterDto: CreateCounselingCenterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounselingCenterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCounselingCenterByAdmin(createCounselingCenterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a legal entity.
         * @param {CreateLegalEntityDto} createLegalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLegalEntityByAdmin(createLegalEntityDto: CreateLegalEntityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLegalEntityByAdmin(createLegalEntityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a lookup value.
         * @param {CreateLookupValueDto} createLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLookupValueByAdmin(createLookupValueDto: CreateLookupValueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditableLookupValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLookupValueByAdmin(createLookupValueDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAclFromCounselingCenterByAdmin(id: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAclFromCounselingCenterByAdmin(id, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user from legal entity
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAclFromLegalEntityByAdmin(id: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAclFromLegalEntityByAdmin(id, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAclsFromCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAclsFromCounselingCenterByAdmin(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllAclsFromCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllAclsFromCounselingCenterByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCounselingCenterByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a legal entity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLegalEntityByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLegalEntityByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a lookup value
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLookupValueByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLookupValueByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAdvisors(limit?: number, offset?: number, sort?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAdvisors(limit, offset, sort, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {string} [searchTerm] term for case insensitive contains search
         * @param {string} [counselingCenterIds] comma separated list of counseling center ids
         * @param {string} [counselingCenterAreas] comma separated list of counseling center ids
         * @param {string} [advisorIds] comma separated list of advisor ids
         * @param {AppointmentType} [type] type of an the appointment
         * @param {string} [clientId] id of a client
         * @param {string} [timeFrom] time from
         * @param {string} [timeUntil] time until
         * @param {boolean} [cancelled] can be true, false or null
         * @param {boolean} [notCancelledByAdvisor] return all appointments which are either not cancelled or cancelled by CLIENT
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAppointments(searchTerm?: string, counselingCenterIds?: string, counselingCenterAreas?: string, advisorIds?: string, type?: AppointmentType, clientId?: string, timeFrom?: string, timeUntil?: string, cancelled?: boolean, notCancelledByAdvisor?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAppointments(searchTerm, counselingCenterIds, counselingCenterAreas, advisorIds, type, clientId, timeFrom, timeUntil, cancelled, notCancelledByAdvisor, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find clients by filtered by criteria.
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [term] term for case insensitive contains search
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findClients(ids?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findClients(ids, term, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCounselingCenters(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacetResultCounselingCenterSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCounselingCenters(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCounselingCentersByAdmin(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacetResultCounselingCenterSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCounselingCentersByAdmin(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find legal entities by given parameters.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [area] professional area
         * @param {RegionType} [region] 
         * @param {ObjectStatus} [status] Status
         * @param {string} [locationFulltext] 
         * @param {string} [name] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLegalEntitiesByAdmin(term?: string, ids?: string, area?: string, region?: RegionType, status?: ObjectStatus, locationFulltext?: string, name?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultLegalEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLegalEntitiesByAdmin(term, ids, area, region, status, locationFulltext, name, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLookupValues(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultLookupValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLookupValues(types, area, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLookupValuesByAdmin(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultEditableLookupValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLookupValuesByAdmin(types, area, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find users by filtered by criteria.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [legalEntityIds] Comma separated list of legal entity ids
         * @param {string} [area] Area the user is assigned to
         * @param {RegionType} [legalEntityRegion] Region of the legal entity the user belongs to
         * @param {string} [counselingCenterIds] Comma seperated list of counseling center ids
         * @param {string} [role] Role the user is assigned to
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUser(term?: string, ids?: string, legalEntityIds?: string, area?: string, legalEntityRegion?: RegionType, counselingCenterIds?: string, role?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUser(term, ids, legalEntityIds, area, legalEntityRegion, counselingCenterIds, role, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all users from counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAclFromCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAclFromCounselingCenterByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all users from legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAclFromLegalEntityByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAclFromLegalEntityByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRegions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRegions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get general info about the app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {AppointmentDto} [appointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentMeetingUrl(id: string, appointmentDto?: AppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentMeetingUrl(id, appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get signed token used to start chat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a counseling center by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCounselingCenter(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounselingCenterDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCounselingCenter(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounselingCenterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCounselingCenterByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current user data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download XLS Export for counseling centers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExport(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExport(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download XLS Export for legal entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExport1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExport1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a legal entity by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegalEntity(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegalEntity(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegalEntityByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegalEntityByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a lookup value by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLookupValueByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditableLookupValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLookupValueByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} token 
         * @param {string} username 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessages(token: string, username: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessages(token, username, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the current application settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SettingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of users in a room
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserList(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserList(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login a client
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest?: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout a client
         * @param {LogoutRequest} [logoutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(logoutRequest?: LogoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(logoutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refresh token
         * @param {RefreshRequest} [refreshRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAccessToken(refreshRequest?: RefreshRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAccessToken(refreshRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register a new client
         * @param {RegistrationRequest} [registrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registrationRequest?: RegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a client
         * @param {RemoveClientDto} [removeClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(removeClientDto?: RemoveClientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(removeClientDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a client
         * @param {UpdateClientDto} [updateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateClientDto?: UpdateClientDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntityObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateClientDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an appointment.
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointment(id: string, appointmentDto: AppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointment(id, appointmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a counseling center.
         * @param {string} id 
         * @param {CounselingCenterDto} counselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCounselingCenterByAdmin(id: string, counselingCenterDto: CounselingCenterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounselingCenterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCounselingCenterByAdmin(id, counselingCenterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a legal entity.
         * @param {string} id 
         * @param {LegalEntityDto} legalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLegalEntityByAdmin(id: string, legalEntityDto: LegalEntityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLegalEntityByAdmin(id, legalEntityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a lookup value.
         * @param {string} id 
         * @param {EditableLookupValueDto} editableLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLookupValueByAdmin(id: string, editableLookupValueDto: EditableLookupValueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditableLookupValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLookupValueByAdmin(id, editableLookupValueDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Add user to counseling center
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclToCounselingCenterByAdmin(id: string, addAclDto: AddAclDto, options?: any): AxiosPromise<void> {
            return localVarFp.addAclToCounselingCenterByAdmin(id, addAclDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add user to legal entity
         * @param {string} id 
         * @param {AddAclDto} addAclDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclToLegalEntityByAdmin(id: string, addAclDto: AddAclDto, options?: any): AxiosPromise<void> {
            return localVarFp.addAclToLegalEntityByAdmin(id, addAclDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add users to counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAclsToCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.addAclsToCounselingCenterByAdmin(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {CancelAppointmentDto} [cancelAppointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment(id: string, cancelAppointmentDto?: CancelAppointmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.cancelAppointment(id, cancelAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new appointment.
         * @param {CreateAppointmentDto} createAppointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(createAppointmentDto: CreateAppointmentDto, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.createAppointment(createAppointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a counseling center.
         * @param {CreateCounselingCenterDto} createCounselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCounselingCenterByAdmin(createCounselingCenterDto: CreateCounselingCenterDto, options?: any): AxiosPromise<CounselingCenterDto> {
            return localVarFp.createCounselingCenterByAdmin(createCounselingCenterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a legal entity.
         * @param {CreateLegalEntityDto} createLegalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegalEntityByAdmin(createLegalEntityDto: CreateLegalEntityDto, options?: any): AxiosPromise<LegalEntityDto> {
            return localVarFp.createLegalEntityByAdmin(createLegalEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a lookup value.
         * @param {CreateLookupValueDto} createLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLookupValueByAdmin(createLookupValueDto: CreateLookupValueDto, options?: any): AxiosPromise<EditableLookupValueDto> {
            return localVarFp.createLookupValueByAdmin(createLookupValueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclFromCounselingCenterByAdmin(id: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAclFromCounselingCenterByAdmin(id, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user from legal entity
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclFromLegalEntityByAdmin(id: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAclFromLegalEntityByAdmin(id, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAclsFromCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAclsFromCounselingCenterByAdmin(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user from counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllAclsFromCounselingCenterByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAllAclsFromCounselingCenterByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a counseling center
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCounselingCenterByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCounselingCenterByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a legal entity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegalEntityByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLegalEntityByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a lookup value
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookupValueByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLookupValueByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdvisors(limit?: number, offset?: number, sort?: string, body?: object, options?: any): AxiosPromise<ResultString> {
            return localVarFp.findAdvisors(limit, offset, sort, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find advisors by filtered by criteria.
         * @param {string} [searchTerm] term for case insensitive contains search
         * @param {string} [counselingCenterIds] comma separated list of counseling center ids
         * @param {string} [counselingCenterAreas] comma separated list of counseling center ids
         * @param {string} [advisorIds] comma separated list of advisor ids
         * @param {AppointmentType} [type] type of an the appointment
         * @param {string} [clientId] id of a client
         * @param {string} [timeFrom] time from
         * @param {string} [timeUntil] time until
         * @param {boolean} [cancelled] can be true, false or null
         * @param {boolean} [notCancelledByAdvisor] return all appointments which are either not cancelled or cancelled by CLIENT
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAppointments(searchTerm?: string, counselingCenterIds?: string, counselingCenterAreas?: string, advisorIds?: string, type?: AppointmentType, clientId?: string, timeFrom?: string, timeUntil?: string, cancelled?: boolean, notCancelledByAdvisor?: boolean, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultAppointmentDto> {
            return localVarFp.findAppointments(searchTerm, counselingCenterIds, counselingCenterAreas, advisorIds, type, clientId, timeFrom, timeUntil, cancelled, notCancelledByAdvisor, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find clients by filtered by criteria.
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [term] term for case insensitive contains search
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClients(ids?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultClientDto> {
            return localVarFp.findClients(ids, term, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCounselingCenters(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<FacetResultCounselingCenterSearchResultDto> {
            return localVarFp.findCounselingCenters(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find counseling centers by given parameters.
         * @param {string} [term] 
         * @param {string} [legalEntityId] 
         * @param {string} [lookupValueIds] 
         * @param {number} [longitude] 
         * @param {number} [latitude] 
         * @param {number} [maxDistance] 
         * @param {string} [facetTypes] 
         * @param {RegionType} [region] 
         * @param {string} [area] 
         * @param {ObjectStatus} [status] 
         * @param {string} [updatedAtFrom] 
         * @param {string} [updatedAtTo] 
         * @param {string} [locationFulltext] 
         * @param {boolean} [withOnlineCounseling] 
         * @param {boolean} [withChatCounseling] 
         * @param {boolean} [withVideoCounseling] 
         * @param {boolean} [withMailCounseling] 
         * @param {CounselingSystemType} [mailCounselingSystem] 
         * @param {CounselingSystemType} [videoCounselingSystem] 
         * @param {CounselingSystemType} [chatCounselingSystem] 
         * @param {boolean} [withInternalCounseling] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCounselingCentersByAdmin(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<FacetResultCounselingCenterSearchResultDto> {
            return localVarFp.findCounselingCentersByAdmin(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find legal entities by given parameters.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [area] professional area
         * @param {RegionType} [region] 
         * @param {ObjectStatus} [status] Status
         * @param {string} [locationFulltext] 
         * @param {string} [name] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLegalEntitiesByAdmin(term?: string, ids?: string, area?: string, region?: RegionType, status?: ObjectStatus, locationFulltext?: string, name?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultLegalEntityDto> {
            return localVarFp.findLegalEntitiesByAdmin(term, ids, area, region, status, locationFulltext, name, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLookupValues(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultLookupValueDto> {
            return localVarFp.findLookupValues(types, area, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all lookup values by type.
         * @param {string} [types] Comma separated list of lookup value types
         * @param {string} [area] professional area
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLookupValuesByAdmin(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultEditableLookupValueDto> {
            return localVarFp.findLookupValuesByAdmin(types, area, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find users by filtered by criteria.
         * @param {string} [term] term for case insensitive contains search
         * @param {string} [ids] Comma separated list of ids
         * @param {string} [legalEntityIds] Comma separated list of legal entity ids
         * @param {string} [area] Area the user is assigned to
         * @param {RegionType} [legalEntityRegion] Region of the legal entity the user belongs to
         * @param {string} [counselingCenterIds] Comma seperated list of counseling center ids
         * @param {string} [role] Role the user is assigned to
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser(term?: string, ids?: string, legalEntityIds?: string, area?: string, legalEntityRegion?: RegionType, counselingCenterIds?: string, role?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultUserDto> {
            return localVarFp.findUser(term, ids, legalEntityIds, area, legalEntityRegion, counselingCenterIds, role, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users from counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAclFromCounselingCenterByAdmin(id: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAclFromCounselingCenterByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users from legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAclFromLegalEntityByAdmin(id: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAclFromLegalEntityByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRegions(options?: any): AxiosPromise<Array<RegionDto>> {
            return localVarFp.getAllRegions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get general info about the app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo(options?: any): AxiosPromise<AppInfoDto> {
            return localVarFp.getAppInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(id: string, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.getAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an appointment by given ID.
         * @param {string} id 
         * @param {AppointmentDto} [appointmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentMeetingUrl(id: string, appointmentDto?: AppointmentDto, options?: any): AxiosPromise<string> {
            return localVarFp.getAppointmentMeetingUrl(id, appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signed token used to start chat.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatToken(options?: any): AxiosPromise<ChatTokenDto> {
            return localVarFp.getChatToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a counseling center by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCounselingCenter(id: string, options?: any): AxiosPromise<CounselingCenterDetailsDto> {
            return localVarFp.getCounselingCenter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a counseling center by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCounselingCenterByAdmin(id: string, options?: any): AxiosPromise<CounselingCenterDto> {
            return localVarFp.getCounselingCenterByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): AxiosPromise<UserDto> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download XLS Export for counseling centers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExport(options?: any): AxiosPromise<string> {
            return localVarFp.getExport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download XLS Export for legal entities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExport1(options?: any): AxiosPromise<string> {
            return localVarFp.getExport1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a legal entity by id.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalEntity(id: string, options?: any): AxiosPromise<LegalEntityDto> {
            return localVarFp.getLegalEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a legal entity by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalEntityByAdmin(id: string, options?: any): AxiosPromise<LegalEntityDto> {
            return localVarFp.getLegalEntityByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a lookup value by given ID.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookupValueByAdmin(id: string, options?: any): AxiosPromise<EditableLookupValueDto> {
            return localVarFp.getLookupValueByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} token 
         * @param {string} username 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(token: string, username: string, limit?: number, offset?: number, options?: any): AxiosPromise<void> {
            return localVarFp.getMessages(token, username, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the current application settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: any): AxiosPromise<Array<SettingsDto>> {
            return localVarFp.getSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of users in a room
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.getUserList(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login a client
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout a client
         * @param {LogoutRequest} [logoutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logoutRequest?: LogoutRequest, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.logout(logoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh token
         * @param {RefreshRequest} [refreshRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken(refreshRequest?: RefreshRequest, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.refreshAccessToken(refreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new client
         * @param {RegistrationRequest} [registrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registrationRequest?: RegistrationRequest, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.register(registrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a client
         * @param {RemoveClientDto} [removeClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(removeClientDto?: RemoveClientDto, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.remove(removeClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a client
         * @param {UpdateClientDto} [updateClientDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateClientDto?: UpdateClientDto, options?: any): AxiosPromise<ResponseEntityObject> {
            return localVarFp.update(updateClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an appointment.
         * @param {string} id 
         * @param {AppointmentDto} appointmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment(id: string, appointmentDto: AppointmentDto, options?: any): AxiosPromise<AppointmentDto> {
            return localVarFp.updateAppointment(id, appointmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a counseling center.
         * @param {string} id 
         * @param {CounselingCenterDto} counselingCenterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCounselingCenterByAdmin(id: string, counselingCenterDto: CounselingCenterDto, options?: any): AxiosPromise<CounselingCenterDto> {
            return localVarFp.updateCounselingCenterByAdmin(id, counselingCenterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a legal entity.
         * @param {string} id 
         * @param {LegalEntityDto} legalEntityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegalEntityByAdmin(id: string, legalEntityDto: LegalEntityDto, options?: any): AxiosPromise<LegalEntityDto> {
            return localVarFp.updateLegalEntityByAdmin(id, legalEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a lookup value.
         * @param {string} id 
         * @param {EditableLookupValueDto} editableLookupValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLookupValueByAdmin(id: string, editableLookupValueDto: EditableLookupValueDto, options?: any): AxiosPromise<EditableLookupValueDto> {
            return localVarFp.updateLookupValueByAdmin(id, editableLookupValueDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Add user to counseling center
     * @param {string} id 
     * @param {AddAclDto} addAclDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addAclToCounselingCenterByAdmin(id: string, addAclDto: AddAclDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addAclToCounselingCenterByAdmin(id, addAclDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add user to legal entity
     * @param {string} id 
     * @param {AddAclDto} addAclDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addAclToLegalEntityByAdmin(id: string, addAclDto: AddAclDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addAclToLegalEntityByAdmin(id, addAclDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add users to counseling center
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addAclsToCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addAclsToCounselingCenterByAdmin(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel an appointment
     * @param {string} id 
     * @param {CancelAppointmentDto} [cancelAppointmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelAppointment(id: string, cancelAppointmentDto?: CancelAppointmentDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelAppointment(id, cancelAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new appointment.
     * @param {CreateAppointmentDto} createAppointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAppointment(createAppointmentDto: CreateAppointmentDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAppointment(createAppointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a counseling center.
     * @param {CreateCounselingCenterDto} createCounselingCenterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCounselingCenterByAdmin(createCounselingCenterDto: CreateCounselingCenterDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCounselingCenterByAdmin(createCounselingCenterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a legal entity.
     * @param {CreateLegalEntityDto} createLegalEntityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createLegalEntityByAdmin(createLegalEntityDto: CreateLegalEntityDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createLegalEntityByAdmin(createLegalEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a lookup value.
     * @param {CreateLookupValueDto} createLookupValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createLookupValueByAdmin(createLookupValueDto: CreateLookupValueDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createLookupValueByAdmin(createLookupValueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user from counseling center
     * @param {string} id 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAclFromCounselingCenterByAdmin(id: string, userId: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAclFromCounselingCenterByAdmin(id, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user from legal entity
     * @param {string} id 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAclFromLegalEntityByAdmin(id: string, userId: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAclFromLegalEntityByAdmin(id, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user from counseling center
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAclsFromCounselingCenterByAdmin(id: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAclsFromCounselingCenterByAdmin(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user from counseling center
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAllAclsFromCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAllAclsFromCounselingCenterByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an appointment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAppointment(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a counseling center
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCounselingCenterByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a legal entity
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteLegalEntityByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteLegalEntityByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a lookup value
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteLookupValueByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteLookupValueByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find advisors by filtered by criteria.
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findAdvisors(limit?: number, offset?: number, sort?: string, body?: object, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findAdvisors(limit, offset, sort, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find advisors by filtered by criteria.
     * @param {string} [searchTerm] term for case insensitive contains search
     * @param {string} [counselingCenterIds] comma separated list of counseling center ids
     * @param {string} [counselingCenterAreas] comma separated list of counseling center ids
     * @param {string} [advisorIds] comma separated list of advisor ids
     * @param {AppointmentType} [type] type of an the appointment
     * @param {string} [clientId] id of a client
     * @param {string} [timeFrom] time from
     * @param {string} [timeUntil] time until
     * @param {boolean} [cancelled] can be true, false or null
     * @param {boolean} [notCancelledByAdvisor] return all appointments which are either not cancelled or cancelled by CLIENT
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findAppointments(searchTerm?: string, counselingCenterIds?: string, counselingCenterAreas?: string, advisorIds?: string, type?: AppointmentType, clientId?: string, timeFrom?: string, timeUntil?: string, cancelled?: boolean, notCancelledByAdvisor?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findAppointments(searchTerm, counselingCenterIds, counselingCenterAreas, advisorIds, type, clientId, timeFrom, timeUntil, cancelled, notCancelledByAdvisor, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find clients by filtered by criteria.
     * @param {string} [ids] Comma separated list of ids
     * @param {string} [term] term for case insensitive contains search
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findClients(ids?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findClients(ids, term, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find counseling centers by given parameters.
     * @param {string} [term] 
     * @param {string} [legalEntityId] 
     * @param {string} [lookupValueIds] 
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {number} [maxDistance] 
     * @param {string} [facetTypes] 
     * @param {RegionType} [region] 
     * @param {string} [area] 
     * @param {ObjectStatus} [status] 
     * @param {string} [updatedAtFrom] 
     * @param {string} [updatedAtTo] 
     * @param {string} [locationFulltext] 
     * @param {boolean} [withOnlineCounseling] 
     * @param {boolean} [withChatCounseling] 
     * @param {boolean} [withVideoCounseling] 
     * @param {boolean} [withMailCounseling] 
     * @param {CounselingSystemType} [mailCounselingSystem] 
     * @param {CounselingSystemType} [videoCounselingSystem] 
     * @param {CounselingSystemType} [chatCounselingSystem] 
     * @param {boolean} [withInternalCounseling] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findCounselingCenters(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findCounselingCenters(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find counseling centers by given parameters.
     * @param {string} [term] 
     * @param {string} [legalEntityId] 
     * @param {string} [lookupValueIds] 
     * @param {number} [longitude] 
     * @param {number} [latitude] 
     * @param {number} [maxDistance] 
     * @param {string} [facetTypes] 
     * @param {RegionType} [region] 
     * @param {string} [area] 
     * @param {ObjectStatus} [status] 
     * @param {string} [updatedAtFrom] 
     * @param {string} [updatedAtTo] 
     * @param {string} [locationFulltext] 
     * @param {boolean} [withOnlineCounseling] 
     * @param {boolean} [withChatCounseling] 
     * @param {boolean} [withVideoCounseling] 
     * @param {boolean} [withMailCounseling] 
     * @param {CounselingSystemType} [mailCounselingSystem] 
     * @param {CounselingSystemType} [videoCounselingSystem] 
     * @param {CounselingSystemType} [chatCounselingSystem] 
     * @param {boolean} [withInternalCounseling] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findCounselingCentersByAdmin(term?: string, legalEntityId?: string, lookupValueIds?: string, longitude?: number, latitude?: number, maxDistance?: number, facetTypes?: string, region?: RegionType, area?: string, status?: ObjectStatus, updatedAtFrom?: string, updatedAtTo?: string, locationFulltext?: string, withOnlineCounseling?: boolean, withChatCounseling?: boolean, withVideoCounseling?: boolean, withMailCounseling?: boolean, mailCounselingSystem?: CounselingSystemType, videoCounselingSystem?: CounselingSystemType, chatCounselingSystem?: CounselingSystemType, withInternalCounseling?: boolean, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findCounselingCentersByAdmin(term, legalEntityId, lookupValueIds, longitude, latitude, maxDistance, facetTypes, region, area, status, updatedAtFrom, updatedAtTo, locationFulltext, withOnlineCounseling, withChatCounseling, withVideoCounseling, withMailCounseling, mailCounselingSystem, videoCounselingSystem, chatCounselingSystem, withInternalCounseling, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find legal entities by given parameters.
     * @param {string} [term] term for case insensitive contains search
     * @param {string} [ids] Comma separated list of ids
     * @param {string} [area] professional area
     * @param {RegionType} [region] 
     * @param {ObjectStatus} [status] Status
     * @param {string} [locationFulltext] 
     * @param {string} [name] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findLegalEntitiesByAdmin(term?: string, ids?: string, area?: string, region?: RegionType, status?: ObjectStatus, locationFulltext?: string, name?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findLegalEntitiesByAdmin(term, ids, area, region, status, locationFulltext, name, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all lookup values by type.
     * @param {string} [types] Comma separated list of lookup value types
     * @param {string} [area] professional area
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findLookupValues(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findLookupValues(types, area, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all lookup values by type.
     * @param {string} [types] Comma separated list of lookup value types
     * @param {string} [area] professional area
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findLookupValuesByAdmin(types?: string, area?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findLookupValuesByAdmin(types, area, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find users by filtered by criteria.
     * @param {string} [term] term for case insensitive contains search
     * @param {string} [ids] Comma separated list of ids
     * @param {string} [legalEntityIds] Comma separated list of legal entity ids
     * @param {string} [area] Area the user is assigned to
     * @param {RegionType} [legalEntityRegion] Region of the legal entity the user belongs to
     * @param {string} [counselingCenterIds] Comma seperated list of counseling center ids
     * @param {string} [role] Role the user is assigned to
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findUser(term?: string, ids?: string, legalEntityIds?: string, area?: string, legalEntityRegion?: RegionType, counselingCenterIds?: string, role?: string, limit?: number, offset?: number, sort?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findUser(term, ids, legalEntityIds, area, legalEntityRegion, counselingCenterIds, role, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users from counseling center by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAclFromCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAclFromCounselingCenterByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users from legal entity by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAclFromLegalEntityByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAclFromLegalEntityByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all regions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllRegions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllRegions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get general info about the app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAppInfo(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAppInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an appointment by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAppointment(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an appointment by given ID.
     * @param {string} id 
     * @param {AppointmentDto} [appointmentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAppointmentMeetingUrl(id: string, appointmentDto?: AppointmentDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAppointmentMeetingUrl(id, appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signed token used to start chat.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChatToken(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChatToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a counseling center by id.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCounselingCenter(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCounselingCenter(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a counseling center by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCounselingCenterByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCounselingCenterByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentUser(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download XLS Export for counseling centers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getExport(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download XLS Export for legal entities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getExport1(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getExport1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a legal entity by id.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLegalEntity(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLegalEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a legal entity by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLegalEntityByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLegalEntityByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a lookup value by given ID.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLookupValueByAdmin(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLookupValueByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get messages for a user
     * @param {string} token 
     * @param {string} username 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMessages(token: string, username: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMessages(token, username, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the current application settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSettings(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of users in a room
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserList(token: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserList(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login a client
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public login(loginRequest?: LoginRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout a client
     * @param {LogoutRequest} [logoutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logout(logoutRequest?: LogoutRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logout(logoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh token
     * @param {RefreshRequest} [refreshRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshAccessToken(refreshRequest?: RefreshRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshAccessToken(refreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new client
     * @param {RegistrationRequest} [registrationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public register(registrationRequest?: RegistrationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).register(registrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a client
     * @param {RemoveClientDto} [removeClientDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remove(removeClientDto?: RemoveClientDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remove(removeClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a client
     * @param {UpdateClientDto} [updateClientDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public update(updateClientDto?: UpdateClientDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).update(updateClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an appointment.
     * @param {string} id 
     * @param {AppointmentDto} appointmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAppointment(id: string, appointmentDto: AppointmentDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAppointment(id, appointmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a counseling center.
     * @param {string} id 
     * @param {CounselingCenterDto} counselingCenterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCounselingCenterByAdmin(id: string, counselingCenterDto: CounselingCenterDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCounselingCenterByAdmin(id, counselingCenterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a legal entity.
     * @param {string} id 
     * @param {LegalEntityDto} legalEntityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateLegalEntityByAdmin(id: string, legalEntityDto: LegalEntityDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateLegalEntityByAdmin(id, legalEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a lookup value.
     * @param {string} id 
     * @param {EditableLookupValueDto} editableLookupValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateLookupValueByAdmin(id: string, editableLookupValueDto: EditableLookupValueDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateLookupValueByAdmin(id, editableLookupValueDto, options).then((request) => request(this.axios, this.basePath));
    }
}


